import { render, staticRenderFns } from "./WorkHoursEdit.vue?vue&type=template&id=7809e4f0"
import script from "./WorkHoursEdit.vue?vue&type=script&lang=ts"
export * from "./WorkHoursEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports